import React, { Component, useState, useEffect } from "react";
import styled from "styled-components";

const StyledError = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.red};
  max-width: 280px;

  svg {
    margin-bottom: 20px;
  }
`;

export default function ErrorInput({
  message,
  validateText,
  regexPattern,
  style,
  onInvalid,
  onValid
}) {
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    const validText = regexPattern.test(validateText);
    setIsValid(validText);
    if (!validText) {
      onInvalid();
      return;
    }
    onValid();
  }, [validateText]);

  if (isValid) return <></>;
  return <StyledError style={style}>{message}</StyledError>;
}
